/* ============================================================================
FILE: po-katupirsia5-lulaesirasen-texts-fr-en-es-20260303.js
MODE: JS FR/EN/ES (injection tri) + lexicon override (termes FR) si présent
API:  window.PoKatupirsia5LulaesirasenTextsFR_EN_ES_20260303
============================================================================ */

(function(){
  "use strict";

  if (window.__PO_K5_LULAESIRASEN_TEXTS_20260303__) return;
  window.__PO_K5_LULAESIRASEN_TEXTS_20260303__ = true;

  var STORAGE_KEY = "po_lex_lang";
  var STORAGE_KEY_COMPAT = "goody_gp_lang";
  var AXIS_LEX_ID = "lulaesirasen";
  var ROOT_SEL =
    '.po-k5-section[data-po-k5="' + AXIS_LEX_ID + '"], ' +
    '.po-axis-section[data-po-axis][data-po-lex-id="' + AXIS_LEX_ID + '"], ' +
    '.po-axis-section[data-po-axis="' + AXIS_LEX_ID + '"], ' +
    '.po-axis-section[data-po-lex-id="' + AXIS_LEX_ID + '"]';

  function clampStr(v){ return (v == null) ? "" : String(v); }
  function qsa(root, sel){ try{ return Array.prototype.slice.call(root.querySelectorAll(sel)); }catch(e){ return []; } }

  function normLang(raw){
    var s = clampStr(raw).toLowerCase().trim();
    if (s === "fr" || s === "en" || s === "es") return s;
    return "fr";
  }

  function readStoredLang(){
    var v = "";
    try{ v = localStorage.getItem(STORAGE_KEY) || ""; }catch(e){ v = ""; }
    if (!v){
      try{ v = localStorage.getItem(STORAGE_KEY_COMPAT) || ""; }catch(_e){ v = ""; }
    }
    return normLang(v || "fr");
  }

  function storeLang(lang){
    var l = normLang(lang);
    try{ localStorage.setItem(STORAGE_KEY, l); }catch(e){}
    try{ localStorage.setItem(STORAGE_KEY_COMPAT, l); }catch(_e){}
    try{
      if (document && document.documentElement){
        document.documentElement.setAttribute("lang", l);
      }
    }catch(__e){}
    return l;
  }

  function getLang(){ return readStoredLang(); }

  function notifyLocaleChanged(){
    try{
      window.dispatchEvent(new Event("po:locale-changed"));
    }catch(e){
      try{
        var ev = document.createEvent("Event");
        ev.initEvent("po:locale-changed", true, true);
        window.dispatchEvent(ev);
      }catch(_e){}
    }
  }

  /* --------------------------------------------------------------------------
   * LEXIQUE RUNTIME
   * -------------------------------------------------------------------------- */

  function getLexiconEntry(id){
    try{
      if (window.PO_LEXICON_MAP && window.PO_LEXICON_MAP[id]) return window.PO_LEXICON_MAP[id];
    }catch(e){}
    try{
      var arr = window.PO_LEXICON;
      if (Array.isArray(arr)){
        for (var i=0;i<arr.length;i++){
          if (arr[i] && arr[i].id === id) return arr[i];
        }
      }
    }catch(e){}
    return null;
  }

  function pickTerm(entry, lang){
    if (!entry) return "";
    try{
      if (entry.terms && entry.terms[lang]) return clampStr(entry.terms[lang]);
    }catch(e){}
    return "";
  }

  function pickAny(entry, key, fallback){
    try{
      if (entry && entry[key] != null) return entry[key];
    }catch(e){}
    return fallback;
  }

  /* --------------------------------------------------------------------------
   * PROTECTION fine (DOM-safe)
   * -------------------------------------------------------------------------- */

  function escapeHTML(s){
    return clampStr(s)
      .replace(/&/g,"&amp;")
      .replace(/</g,"&lt;")
      .replace(/>/g,"&gt;")
      .replace(/"/g,"&quot;")
      .replace(/'/g,"&#39;");
  }

  function escapeRegExp(s){
    return String(s).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }

  function uniqPush(arr, v, seen){
    var k = String(v || "");
    if (!k) return;
    if (seen[k]) return;
    seen[k] = true;
    arr.push(k);
  }

  function buildVariants(term){
    var out = [];
    var seen = Object.create(null);
    var t = clampStr(term);
    if (!t) return out;

    uniqPush(out, t, seen);
    uniqPush(out, t.replace(/’/g, "'"), seen);
    uniqPush(out, t.replace(/'/g, "’"), seen);
    uniqPush(out, t.replace(/œ/g, "oe").replace(/Œ/g, "OE"), seen);
    uniqPush(out, t.replace(/oe/g, "œ").replace(/OE/g, "Œ"), seen);

    var oe1 = t.replace(/œ/g, "oe").replace(/Œ/g, "OE");
    var oe2 = t.replace(/oe/g, "œ").replace(/OE/g, "Œ");
    uniqPush(out, oe1.replace(/’/g, "'"), seen);
    uniqPush(out, oe1.replace(/'/g, "’"), seen);
    uniqPush(out, oe2.replace(/’/g, "'"), seen);
    uniqPush(out, oe2.replace(/'/g, "’"), seen);

    return out;
  }

  function getSimplifiedLexiqueFRList(){
    try{
      if (window.PO_LEXICON_META && Array.isArray(window.PO_LEXICON_META.lexique_simplifie_fr)){
        return window.PO_LEXICON_META.lexique_simplifie_fr.slice();
      }
    }catch(e){}
    try{
      if (window.PO_LEXICON && window.PO_LEXICON.meta && Array.isArray(window.PO_LEXICON.meta.lexique_simplifie_fr)){
        return window.PO_LEXICON.meta.lexique_simplifie_fr.slice();
      }
    }catch(e){}
    try{
      if (window.PO_LEXIQUE_SIMPLIFIE && window.PO_LEXIQUE_SIMPLIFIE.meta && Array.isArray(window.PO_LEXIQUE_SIMPLIFIE.meta.lexique_simplifie_fr)){
        return window.PO_LEXIQUE_SIMPLIFIE.meta.lexique_simplifie_fr.slice();
      }
    }catch(e){}

    return [
      "Posœnnoïa",
      "Posœnnoïsme",
      "Organon posœnnoïal",
      "Katûvýs",
      "Katûsýs",
      "Balakallpa",
      "Lulæṣírasen",
      "Takimarah",
      "Taxiêlîs",
      "Tiqqunbahu",
      "Katûvýsissence",
      "Extratinrieur",
      "Ušôprogalenmestûd",
      "Mathêsis ontologique posœnnoïale",
      "MOPo",
      "RéZonans",
      "RéZonansement",
      "Katûvýsqun",
      "Addition synchrêtique",
      "Synchrêssion",
      "Àpákan",
      "Êkhö"
    ];
  }

  function buildProtectRegexFromSimplified(){
    var base = getSimplifiedLexiqueFRList();
    if (!base || !base.length) return null;

    var terms = [];
    var seen = Object.create(null);

    for (var i=0;i<base.length;i++){
      var vars = buildVariants(base[i]);
      for (var j=0;j<vars.length;j++){
        uniqPush(terms, vars[j], seen);
      }
    }

    terms.sort(function(a,b){ return b.length - a.length; });

    var parts = [];
    for (var k=0;k<terms.length;k++){
      parts.push(escapeRegExp(terms[k]));
    }
    if (!parts.length) return null;

    try{
      return new RegExp("(" + parts.join("|") + ")", "g");
    }catch(e){
      return null;
    }
  }

  var __PO_PROTECT_CACHE__ = { key:"", re:null };

  function ensureProtectEngineReady(){
    var key = "meta:none";
    try{
      var l = getSimplifiedLexiqueFRList();
      key = "meta:" + (l ? l.length : 0);
    }catch(e){
      key = "meta:none";
    }
    if (__PO_PROTECT_CACHE__.key === key) return;
    __PO_PROTECT_CACHE__.key = key;
    __PO_PROTECT_CACHE__.re = buildProtectRegexFromSimplified();
  }

  function isLockedElement(el){
    if (!el || el.nodeType !== 1) return false;
    var tr = el.getAttribute && el.getAttribute("translate");
    if (tr && String(tr).toLowerCase() === "no") return true;
    var cls = el.className || "";
    if (typeof cls === "string"){
      if (cls.indexOf("notranslate") !== -1) return true;
      if (cls.indexOf("po-lex-protect") !== -1) return true;
      if (cls.indexOf("po-lex-locknode") !== -1) return true;
    }
    return false;
  }

  function isLockedNode(node){
    var el = (node && node.nodeType === 1) ? node : (node ? node.parentElement : null);
    while (el && el.nodeType === 1){
      if (isLockedElement(el)) return true;
      el = el.parentElement;
    }
    return false;
  }

  function isWordLikeChar(ch){
    return /[0-9A-Za-zÀ-ÖØ-öø-ÿ_]/.test(ch);
  }

  function protectTextNode(doc, textNode){
    ensureProtectEngineReady();
    var re = __PO_PROTECT_CACHE__.re;
    if (!re) return;

    var txt = textNode.nodeValue;
    if (!txt) return;

    re.lastIndex = 0;
    if (!re.test(txt)) return;

    re.lastIndex = 0;
    var frag = doc.createDocumentFragment();
    var last = 0;
    var m;

    while ((m = re.exec(txt)) !== null){
      var start = m.index;
      var match = m[0];
      var end = start + match.length;

      if (start > last){
        frag.appendChild(doc.createTextNode(txt.slice(last, start)));
      }

      var chPrev = (start - 1 >= 0) ? txt.charAt(start - 1) : "";
      if (chPrev && isWordLikeChar(chPrev)){
        frag.appendChild(doc.createTextNode(" "));
      }

      var span = doc.createElement("span");
      span.setAttribute("translate", "no");
      span.className = "po-lex-protect notranslate";
      span.textContent = match;
      frag.appendChild(span);

      var chNext = (end < txt.length) ? txt.charAt(end) : "";
      if (chNext && isWordLikeChar(chNext)){
        frag.appendChild(doc.createTextNode(" "));
      }

      last = end;
      if (match.length === 0) break;
    }

    if (last < txt.length){
      frag.appendChild(doc.createTextNode(txt.slice(last)));
    }

    if (textNode.parentNode){
      textNode.parentNode.replaceChild(frag, textNode);
    }
  }

  function protectKeywordsHTML(html){
    if (!html) return "";
    ensureProtectEngineReady();
    if (!__PO_PROTECT_CACHE__.re) return String(html);

    var tpl = document.createElement("template");
    tpl.innerHTML = String(html);
    var root = tpl.content || tpl;

    var walker;
    try{
      walker = document.createTreeWalker(
        root,
        NodeFilter.SHOW_TEXT,
        {
          acceptNode: function(n){
            if (!n || !n.nodeValue) return NodeFilter.FILTER_REJECT;
            if (isLockedNode(n)) return NodeFilter.FILTER_REJECT;
            return NodeFilter.FILTER_ACCEPT;
          }
        },
        false
      );
    }catch(e){
      return String(html);
    }

    var nodes = [];
    var n;
    while ((n = walker.nextNode())) nodes.push(n);

    for (var i=0;i<nodes.length;i++){
      protectTextNode(document, nodes[i]);
    }

    return tpl.innerHTML;
  }

  /* --------------------------------------------------------------------------
   * AUDIO
   * -------------------------------------------------------------------------- */

  var PO_AUDIO_SYNTH = (typeof window !== "undefined" && window.speechSynthesis) ? window.speechSynthesis : null;
  var PO_AUDIO_STATE = {
    root: null,
    units: [],
    unitPos: -1,
    chunks: [],
    chunkPos: -1,
    activeKey: ""
  };

  var AUDIO_UI = {
    fr: { general: "Écouter le texte", block: "Écouter ce bloc", stop: "Arrêter la lecture" },
    en: { general: "Listen to the text", block: "Listen to this section", stop: "Stop playback" },
    es: { general: "Escuchar el texto", block: "Escuchar este bloque", stop: "Detener la lectura" }
  };

  function audioUI(lang){
    return AUDIO_UI[normLang(lang)] || AUDIO_UI.fr;
  }

  function ensureAudioStyles(){
    if (document.getElementById("po-k5-lulaesirasen-audio-styles")) return;
    var style = document.createElement("style");
    style.id = "po-k5-lulaesirasen-audio-styles";
    style.textContent = [
      '.po-axis-audio-wrap{display:flex;justify-content:center;margin:12px 0 14px;}',
      '.po-audio-btn{appearance:none;-webkit-appearance:none;border:1px solid rgba(0,0,0,.14);background:rgba(0,0,0,.02);color:inherit;border-radius:999px;padding:8px 14px;font:inherit;font-size:12px;line-height:1;cursor:pointer;transition:transform .18s ease,box-shadow .18s ease,border-color .18s ease,background .18s ease;}',
      '.po-audio-btn:hover{transform:translateY(-1px);box-shadow:0 8px 18px rgba(0,0,0,.08);border-color:rgba(0,0,0,.24);}',
      '.po-audio-btn.is-active{border-color:rgba(184,134,11,.55);box-shadow:0 0 0 1px rgba(184,134,11,.18),0 8px 18px rgba(31,122,58,.10);font-weight:700;}',
      '.po-lex-summary .po-audio-btn{margin-left:auto;flex:0 0 auto;}',
      '.po-k5-section[data-po-k5="lulaesirasen"] .po-axis-prose-list{list-style:none!important;margin:10px 12px 12px!important;padding:0!important;}',
      '.po-k5-section[data-po-k5="lulaesirasen"] .po-axis-prose-item{list-style:none!important;margin:0 0 12px!important;padding:0!important;line-height:1.62;}',
      '.po-k5-section[data-po-k5="lulaesirasen"] .po-axis-prose-item:last-child{margin-bottom:0!important;}',
      '@media (max-width:640px){.po-lex-summary{flex-wrap:wrap;}.po-lex-summary .po-audio-btn{order:3;margin-left:0;}}'
    ].join('');
    document.head.appendChild(style);
  }

  function createAudioButton(role){
    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "po-audio-btn notranslate";
    btn.setAttribute("translate", "no");
    btn.setAttribute("data-po-audio-role", role);
    return btn;
  }

  function ensureAudioButtons(root, lang){
    if (!root) return;
    ensureAudioStyles();

    var panel = root.querySelector(".po-lex-panel");
    if (panel){
      var generalWrap = root.querySelector(".po-axis-audio-wrap[data-po-audio-role='general']");
      if (!generalWrap){
        generalWrap = document.createElement("div");
        generalWrap.className = "po-axis-audio-wrap notranslate";
        generalWrap.setAttribute("translate", "no");
        generalWrap.setAttribute("data-po-audio-role", "general");
        generalWrap.appendChild(createAudioButton("general"));

        var meta = root.querySelector(".po-axis-meta");
        var defShort = root.querySelector("[data-po-slot='def_short']");
        var firstDetail = panel.querySelector(".po-lex-details");
        if (meta && meta.parentNode){
          if (meta.nextSibling) meta.parentNode.insertBefore(generalWrap, meta.nextSibling);
          else meta.parentNode.appendChild(generalWrap);
        }else if (defShort && defShort.parentNode){
          defShort.parentNode.insertBefore(generalWrap, defShort);
        }else if (firstDetail && firstDetail.parentNode){
          firstDetail.parentNode.insertBefore(generalWrap, firstDetail);
        }else{
          panel.appendChild(generalWrap);
        }
      }
    }

    qsa(root, ".po-lex-details").forEach(function(details, idx){
      var summary = details.querySelector(".po-lex-summary");
      if (!summary) return;
      var btn = summary.querySelector(".po-audio-btn[data-po-audio-role='block']");
      if (!btn){
        btn = createAudioButton("block");
        btn.setAttribute("data-po-audio-index", String(idx));
        summary.appendChild(btn);
      }else{
        btn.setAttribute("data-po-audio-index", String(idx));
      }
    });

    bindAudioButtons(root, lang);
  }

  function refreshAudioButtons(root, lang){
    var ui = audioUI(lang);
    qsa(root, ".po-audio-btn").forEach(function(btn){
      var role = btn.getAttribute("data-po-audio-role");
      var key = role === "general" ? "general" : ("block:" + (btn.getAttribute("data-po-audio-index") || "0"));
      var active = (PO_AUDIO_STATE.root === root && PO_AUDIO_STATE.activeKey === key);
      btn.textContent = active ? ui.stop : (role === "general" ? ui.general : ui.block);
      btn.classList.toggle("is-active", !!active);
      btn.setAttribute("aria-pressed", active ? "true" : "false");
    });
  }

  function bindAudioButtons(root, lang){
    qsa(root, ".po-audio-btn").forEach(function(btn){
      if (btn.__poAudioBound) return;
      btn.__poAudioBound = true;
      btn.addEventListener("click", function(ev){
        ev.preventDefault();
        ev.stopPropagation();
        var role = btn.getAttribute("data-po-audio-role");
        var key = role === "general" ? "general" : ("block:" + (btn.getAttribute("data-po-audio-index") || "0"));
        if (PO_AUDIO_STATE.root === root && PO_AUDIO_STATE.activeKey === key){
          stopAudio();
          refreshAudioButtons(root, getLang());
          return;
        }
        startAudio(root, getLang(), key);
      });
    });
  }

  function textFromNode(node){
    if (!node) return "";
    var clone = node.cloneNode(true);
    qsa(clone, "script,style,.po-audio-btn,.po-lex-summary__hint").forEach(function(el){
      if (el && el.parentNode) el.parentNode.removeChild(el);
    });
    var txt = (clone.innerText || clone.textContent || "")
      .replace(/\s+/g, " ")
      .replace(/\s([:;!?])/g, "$1")
      .trim();
    return txt;
  }

  function buildIntroText(root){
    var parts = [];
    ["title","kicker","h_def","def_short","def_long"].forEach(function(slot){
      var node = root.querySelector("[data-po-slot='" + slot + "']");
      var txt = textFromNode(node);
      if (txt) parts.push(txt);
    });
    var meta = root.querySelector(".po-axis-meta");
    var metaTxt = textFromNode(meta);
    if (metaTxt) parts.push(metaTxt);
    return parts.join(". ");
  }

  function buildBlockText(details){
    if (!details) return "";
    var parts = [];
    var summary = details.querySelector(".po-lex-summary");
    if (summary){
      var title = textFromNode(summary.querySelector(".po-lex-summary__title"));
      if (title) parts.push(title);
    }

    var clone = details.cloneNode(true);
    clone.open = true;

    var clonedSummary = clone.querySelector(".po-lex-summary");
    if (clonedSummary && clonedSummary.parentNode){
      clonedSummary.parentNode.removeChild(clonedSummary);
    }

    qsa(clone, ".po-audio-btn,.po-lex-summary__hint").forEach(function(el){
      if (el && el.parentNode) el.parentNode.removeChild(el);
    });

    var txt = textFromNode(clone);
    if (txt) parts.push(txt);
    return parts.join(". ");
  }

  function splitTextForSpeech(text){
    var raw = clampStr(text).replace(/\s+/g, " ").trim();
    if (!raw) return [];
    var sentences = raw.match(/[^.!?]+[.!?…]?/g) || [raw];
    var chunks = [];
    var current = "";
    sentences.forEach(function(sentence){
      var s = sentence.trim();
      if (!s) return;
      if (!current){
        current = s;
        return;
      }
      if ((current + " " + s).length <= 210){
        current += " " + s;
      } else {
        chunks.push(current);
        current = s;
      }
    });
    if (current) chunks.push(current);
    return chunks;
  }

  function pickVoice(lang){
    if (!PO_AUDIO_SYNTH || !PO_AUDIO_SYNTH.getVoices) return null;
    var voices = PO_AUDIO_SYNTH.getVoices() || [];
    var targets = lang === "en" ? ["en"] : (lang === "es" ? ["es"] : ["fr"]);
    for (var i=0;i<voices.length;i++){
      var vlang = clampStr(voices[i].lang).toLowerCase();
      for (var j=0;j<targets.length;j++){
        if (vlang.indexOf(targets[j]) === 0) return voices[i];
      }
    }
    return voices[0] || null;
  }

  function stopAudio(){
    if (PO_AUDIO_SYNTH) {
      try { PO_AUDIO_SYNTH.cancel(); } catch(e){}
    }
    PO_AUDIO_STATE.root = null;
    PO_AUDIO_STATE.units = [];
    PO_AUDIO_STATE.unitPos = -1;
    PO_AUDIO_STATE.chunks = [];
    PO_AUDIO_STATE.chunkPos = -1;
    PO_AUDIO_STATE.activeKey = "";
    qsa(document, ROOT_SEL).forEach(function(root){ refreshAudioButtons(root, getLang()); });
  }

  function speakNextChunk(lang){
    if (!PO_AUDIO_SYNTH || !PO_AUDIO_STATE.chunks.length) {
      speakNextUnit(lang);
      return;
    }
    PO_AUDIO_STATE.chunkPos += 1;
    if (PO_AUDIO_STATE.chunkPos >= PO_AUDIO_STATE.chunks.length){
      speakNextUnit(lang);
      return;
    }
    var utter = new SpeechSynthesisUtterance(PO_AUDIO_STATE.chunks[PO_AUDIO_STATE.chunkPos]);
    var voice = pickVoice(lang);
    if (voice) utter.voice = voice;
    utter.lang = lang === "en" ? "en-US" : (lang === "es" ? "es-ES" : "fr-FR");
    utter.onend = function(){ speakNextChunk(lang); };
    utter.onerror = function(){ speakNextChunk(lang); };
    try { PO_AUDIO_SYNTH.speak(utter); } catch(e){ speakNextChunk(lang); }
  }

  function speakNextUnit(lang){
    PO_AUDIO_STATE.unitPos += 1;
    if (PO_AUDIO_STATE.unitPos >= PO_AUDIO_STATE.units.length){
      stopAudio();
      return;
    }

    var unit = PO_AUDIO_STATE.units[PO_AUDIO_STATE.unitPos];
    if (unit.node && unit.node.tagName && unit.node.tagName.toLowerCase() === "details"){
      unit.node.open = true;
    }

    PO_AUDIO_STATE.activeKey = unit.key;
    if (PO_AUDIO_STATE.root){
      refreshAudioButtons(PO_AUDIO_STATE.root, lang);
    }

    PO_AUDIO_STATE.chunks = splitTextForSpeech(unit.text);
    PO_AUDIO_STATE.chunkPos = -1;
    speakNextChunk(lang);
  }

  function buildUnits(root, key){
    var units = [];
    if (key === "general"){
      var intro = buildIntroText(root);
      if (intro) units.push({ key:"general", node: root, text: intro });
      qsa(root, ".po-lex-details").forEach(function(details, idx){
        var txt = buildBlockText(details);
        if (txt) units.push({ key:"block:" + idx, node: details, text: txt });
      });
      return units;
    }
    var idx = parseInt(String(key).split(":")[1], 10);
    if (isNaN(idx)) idx = 0;
    qsa(root, ".po-lex-details").forEach(function(details, pos){
      if (pos < idx) return;
      var txt = buildBlockText(details);
      if (txt) units.push({ key:"block:" + pos, node: details, text: txt });
    });
    return units;
  }

  function startAudio(root, lang, key){
    if (!PO_AUDIO_SYNTH){
      refreshAudioButtons(root, lang);
      return;
    }
    try { PO_AUDIO_SYNTH.cancel(); } catch(e){}
    PO_AUDIO_STATE.root = root;
    PO_AUDIO_STATE.units = buildUnits(root, key);
    PO_AUDIO_STATE.unitPos = -1;
    PO_AUDIO_STATE.chunks = [];
    PO_AUDIO_STATE.chunkPos = -1;
    PO_AUDIO_STATE.activeKey = key;
    refreshAudioButtons(root, lang);
    if (!PO_AUDIO_STATE.units.length){
      stopAudio();
      return;
    }
    speakNextUnit(lang);
  }

  try{
    if (PO_AUDIO_SYNTH && typeof PO_AUDIO_SYNTH.addEventListener === "function"){
      PO_AUDIO_SYNTH.addEventListener("voiceschanged", function(){
        qsa(document, ROOT_SEL).forEach(function(root){
          refreshAudioButtons(root, getLang());
        });
      });
    }
  }catch(e){}

  /* --------------------------------------------------------------------------
   * TEXTES TRILINGUES — LULÆṢÍRASEN
   * -------------------------------------------------------------------------- */

  var IMG_IDEOGRAM_CONCEPT = "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Lulae_irasen_copie_2.png?v=1772886087";
  var IMG_IDEOGRAM_FUNCTION = "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Lulae_irasen_fonctionnel.png?v=1773452618";
  var IMG_ELEMENT = "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Katuvys_copie.png?v=1750254535";
  var IMG_TOTEM = "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Ekho.png?v=1773404195";
  var IMG_FREQ_136 = "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Nombre_guide_136.png?v=1773410991";

  var FALLBACK = {
    "fr": {
        "title": "Lulæṣírasen",
        "kicker": "Extrait du <em>Katûpirsia&nbsp;5 — La Matrice-substrat</em><br />(Katûsýs : matrice d’impulsion, naissance des vortex et transmutation spiralée)",
        "h_def": "Définition opérative",
        "chips": [
            "Idéogramme fonctionnel",
            "Élément : La Katûvýs",
            "Totem : Êkhö",
            "Fréquence-guide 136"
        ],
        "def_short": "Organe interne de Katûsýs, Lulæṣírasen est la matrice d’impulsion où les écarts de tension se condensent, s’ouvrent en vortex et reçoivent leur première orientation rythmique.",
        "def_long": "Lulæṣírasen occupe, au sein de La Katûvýs, une centralité fonctionnelle de mise en mouvement. Cette matrice d’impulsion rassemble les intensités encore latentes, catalyse leur circulation et leur donne une courbure praticable. Elle ouvre les cycles, les retournements et les basculements d’état par oscillation, contraction et expansion volutée, sans produire une forme close : son geste premier consiste à rendre la transmutation possible.\n\nSon action peut se déployer sous plusieurs configurations vortexiennes. Le vortex libre correspond à une émergence spontanée depuis le champ ; le vortex contraint répond à une pression périphérique ou à l’interaction avec d’autres organes ; le vortex toroïdal organise un retour en boucle où la reprise devient transformation ; les chaînes de vortex alternés accompagnent les passages entre syntonies différenciées. Ces figures appartiennent à la poïétique fonctionnelle du corpus et décrivent des régimes de circulation, de courbure et de relance.\n\nLulæṣírasen impulse et oriente ; Takimarah ajuste l’intensité, la vitesse et la direction du mouvement. Taxiêlîs articule les pivots de phase, Tiqqunbahu reprend les motifs récurrents, tandis que Katûvýsissence inscrit les trajectoires sous forme d’empreintes réactivables. Lulæṣírasen agit ainsi comme foyer intra-katûvýsique d’initiation, en syntonie intérieure avec la Posœnnoïa et distinct d’Extratinrieur, qui ouvre l’interface entre intériorité, extériorité, perception et transmission.",
        "h_features": "Fonction et dynamique interne",
        "h_questions": "Configurations vortexiennes et activation",
        "hint_fold": "déplier",
        "hint_fold2": "déplier",
        "hint_fold3": "déplier",
        "example_title": "Phrase opérative",
        "example": "« Lulæṣírasen : je condense l’écart, j’ouvre l’impulsion, et la spirale devient passage vivant vers la recomposition. »",
        "features": [
            "Lulæṣírasen appartient à Katûsýs, bande des huit organes internes de La Katûvýs. Sa centralité reste fonctionnelle et relationnelle : elle désigne le foyer où une intensité devient mouvement, plutôt qu’un centre dominant ou une origine extérieure à la matrice-substrat.",
            "Sa fonction consiste à condenser les écarts de tension, mettre en vibration les potentialités du champ, catalyser les circulations et orienter leurs variations. L’impulsion y devient rythme, le rythme devient courbure, puis la courbure ouvre un seuil de transmutation.",
            "Le mouvement engagé par Lulæṣírasen reste modulable. Il peut s’amplifier, se contracter, changer de sens rotatoire, se retourner ou se redistribuer selon les besoins du champ. Takimarah assure alors la régulation directionnelle et la tenue des variations, dans une interdépendance où Lulæṣírasen impulse et Takimarah règle."
        ],
        "questions": [
            "L’activation de Lulæṣírasen devient pertinente lorsqu’une tension demeure disponible sans encore trouver sa direction, lorsqu’un cycle demande une impulsion initiale ou lorsqu’une transformation exige une courbure plutôt qu’une poussée linéaire.",
            "Dans un vortex libre, le mouvement émerge depuis le champ lui-même. Dans un vortex contraint, une pression périphérique entretient ou amplifie la rotation. Le vortex toroïdal organise une circulation en boucle, tandis que les chaînes de vortex alternés soutiennent les transitions entre plusieurs syntonies.",
            "Le repère opératif demeure simple : quand le champ demande une mise en mouvement, Lulæṣírasen impulse ; quand cette impulsion exige mesure, canalisation et stabilité mobile, Takimarah règle son déploiement."
        ],
        "h_family": "Relations systémiques",
        "family_1": "<p><strong>Dans Katûsýs :</strong> Lulæṣírasen initie la poussée rythmique ; Taxiêlîs forme les pivots où les syntonies se condensent et se redistribuent ; Tiqqunbahu accueille les reprises en motifs différenciés ; Takimarah module les écarts, les vitesses et les orientations. Cette circulation forme une mécanique relationnelle où l’impulsion garde sa puissance tout en demeurant habitable.</p>",
        "family_2": "<p><strong>Dans La Katûvýs :</strong> les trajectoires issues de Lulæṣírasen s’inscrivent dans Katûvýsissence comme mémoires dynamiques, peuvent franchir Extratinrieur vers les champs perceptifs et expressifs, puis participer à l’émergence de Balakallpa. Lulæṣírasen constitue ainsi une interface interne entre la matrice énergétique et la Posœnnoïa, sans se substituer à leur fonction propre.</p>",
        "h_wordbuild": "Morphogenèse linguistique et fréquence-guide 136",
        "word_blocks": [
            {
                "head": "Lule’a — boucle, attache et relance",
                "text": "Lule’a constitue une transposition morphogénétique posœnnoïale élaborée à partir de l’hébreu lula’a, « boucle ». Le segment porte la logique du retour, de l’attache cyclique et de la tension retenue avant l’ouverture."
            },
            {
                "head": "ṣí — ouverture du passage",
                "text": "Le yorùbá ṣí porte le geste d’ouvrir, de dégager ou de découvrir. Dans Lulæṣírasen, cette ouverture transforme la boucle retenue en seuil opératif et libère la possibilité du mouvement."
            },
            {
                "head": "rasen — courbure spiralée",
                "text": "Le japonais rasen, 螺旋, signifie spirale ou hélice. Il donne au passage sa rotation, sa profondeur et sa capacité d’expansion, afin que l’ouverture devienne trajectoire plutôt que simple rupture."
            },
            {
                "head": "Fréquence-guide 136",
                "text": "La translittération canonique LULEASIRASEN produit 136 : L(12) + U(21) + L(12) + E(5) + A(1) + S(19) + I(9) + R(18) + A(1) + S(19) + E(5) + N(14). La réduction 1 + 3 + 6 = 10, puis 1, ramène la dynamique à l’unité-source et à l’impulsion initiale. Cette valeur agit dans le corpus comme signature symbolique interne, sans équivalence avec une fréquence physique mesurée en hertz."
            }
        ],
        "word_notes": [
            "La construction Lule’a + ṣí + rasen relève de l’Addition synchrêtique : chaque provenance demeure reconnaissable, tandis que leur articulation produit un mot-concept nouveau, propre au corpus.",
            "Le titre Lulæṣírasen, l’élément La Katûvýs, le totem Êkhö et les autres termes canoniques restent inchangés dans les trois langues."
        ],
        "cta_translate": "Proposer une traduction du concept"
    },
    "en": {
        "title": "Lulæṣírasen",
        "kicker": "Excerpt from <em>Katûpirsia&nbsp;5 — La Matrice-substrat</em><br />(Katûsýs: impulse matrix, vortex emergence and spiral transmutation)",
        "h_def": "Operative definition",
        "chips": [
            "Functional ideogram",
            "Element: La Katûvýs",
            "Totem: Êkhö",
            "Guide-frequency 136"
        ],
        "def_short": "An internal organ of Katûsýs, Lulæṣírasen is the impulse matrix where differences in tension condense, open into vortices and receive their first rhythmic orientation.",
        "def_long": "Within La Katûvýs, Lulæṣírasen holds a functional centrality of movement initiation. This impulse matrix gathers still-latent intensities, catalyses their circulation and gives them a practicable curvature. Through oscillation, contraction and voluted expansion, it opens cycles, reversals and shifts of state without producing a closed form: its primary gesture is to make transmutation possible.\n\nIts action may unfold through several vortex configurations. A free vortex corresponds to spontaneous emergence from the field; a forced vortex responds to peripheral pressure or interaction with other organs; a toroidal vortex organises a looping return in which recurrence becomes transformation; chains of alternating vortices accompany passages between differentiated syntonies. These figures belong to the functional poietics of the corpus and describe regimes of circulation, curvature and relaunch.\n\nLulæṣírasen impels and orients; Takimarah adjusts the movement’s intensity, speed and direction. Taxiêlîs articulates phase pivots, Tiqqunbahu takes up recurring motifs, while Katûvýsissence records trajectories as reactivable imprints. Lulæṣírasen thus acts as an intra-katûvýsian focus of initiation, in inner syntony with Posœnnoïa and distinct from Extratinrieur, which opens the interface between interiority, exteriority, perception and transmission.",
        "h_features": "Function and internal dynamics",
        "h_questions": "Vortex configurations and activation",
        "hint_fold": "unfold",
        "hint_fold2": "unfold",
        "hint_fold3": "unfold",
        "example_title": "Operative phrase",
        "example": "“Lulæṣírasen: I condense the difference, I open the impulse, and the spiral becomes a living passage towards recomposition.”",
        "features": [
            "Lulæṣírasen belongs to Katûsýs, the band of eight internal organs of La Katûvýs. Its centrality is functional and relational: it names the focus where intensity becomes movement, rather than a dominant centre or an origin external to the matrix-substrate.",
            "Its function is to condense differences in tension, set the field’s potentialities into vibration, catalyse circulations and orient their variations. Impulse becomes rhythm, rhythm becomes curvature, and curvature opens a threshold of transmutation.",
            "The movement initiated by Lulæṣírasen remains modulable. It may intensify, contract, change rotational direction, reverse or redistribute according to the field’s needs. Takimarah then ensures directional regulation and the holding of variations, within an interdependence where Lulæṣírasen impels and Takimarah regulates."
        ],
        "questions": [
            "Lulæṣírasen becomes relevant when a tension remains available without yet finding its direction, when a cycle requires an initial impulse, or when transformation calls for curvature rather than a linear thrust.",
            "In a free vortex, movement emerges from the field itself. In a forced vortex, peripheral pressure sustains or amplifies rotation. The toroidal vortex organises looping circulation, while chains of alternating vortices support transitions between several syntonies.",
            "The operative marker remains clear: when the field calls for movement, Lulæṣírasen impels; when that impulse requires measure, canalisation and mobile stability, Takimarah regulates its unfolding."
        ],
        "h_family": "Systemic relations",
        "family_1": "<p><strong>Within Katûsýs:</strong> Lulæṣírasen initiates rhythmic thrust; Taxiêlîs forms the pivots where syntonies condense and redistribute; Tiqqunbahu receives recurrence as differentiated motifs; Takimarah modulates differences, speeds and orientations. This circulation forms a relational mechanism in which impulse retains its power while remaining inhabitable.</p>",
        "family_2": "<p><strong>Within La Katûvýs:</strong> trajectories issuing from Lulæṣírasen are recorded in Katûvýsissence as dynamic memories, may cross Extratinrieur towards perceptive and expressive fields, and then participate in the emergence of Balakallpa. Lulæṣírasen is therefore an internal interface between the energetic matrix and Posœnnoïa, without replacing either function.</p>",
        "h_wordbuild": "Linguistic morphogenesis and guide-frequency 136",
        "word_blocks": [
            {
                "head": "Lule’a — loop, attachment and relaunch",
                "text": "Lule’a is a Posœnnoïal morphogenetic transposition developed from Hebrew lula’a, “loop”. The segment carries the logic of return, cyclical attachment and retained tension before opening."
            },
            {
                "head": "ṣí — opening the passage",
                "text": "The Yorùbá ṣí carries the act of opening, clearing or uncovering. In Lulæṣírasen, this opening transforms the retained loop into an operative threshold and releases the possibility of movement."
            },
            {
                "head": "rasen — spiral curvature",
                "text": "The Japanese rasen, 螺旋, means spiral or helix. It gives passage its rotation, depth and capacity for expansion, so that opening becomes a trajectory rather than a mere rupture."
            },
            {
                "head": "Guide-frequency 136",
                "text": "The canonical transliteration LULEASIRASEN produces 136: L(12) + U(21) + L(12) + E(5) + A(1) + S(19) + I(9) + R(18) + A(1) + S(19) + E(5) + N(14). The reduction 1 + 3 + 6 = 10, then 1, returns the dynamic to source-unity and initial impulse. Within the corpus, this value acts as an internal symbolic signature and has no equivalence with a physical frequency measured in hertz."
            }
        ],
        "word_notes": [
            "The construction Lule’a + ṣí + rasen follows Synchrêtic Addition: each provenance remains recognisable while their articulation produces a new word-concept specific to the corpus.",
            "The title Lulæṣírasen, the element La Katûvýs, the totem Êkhö and the other canonical terms remain unchanged in all three languages."
        ],
        "cta_translate": "Suggest a translation of the concept"
    },
    "es": {
        "title": "Lulæṣírasen",
        "kicker": "Extracto de <em>Katûpirsia&nbsp;5 — La Matrice-substrat</em><br />(Katûsýs: matriz de impulso, nacimiento de vórtices y transmutación espiral)",
        "h_def": "Definición operativa",
        "chips": [
            "Ideograma funcional",
            "Elemento: La Katûvýs",
            "Tótem: Êkhö",
            "Frecuencia-guía 136"
        ],
        "def_short": "Órgano interno de Katûsýs, Lulæṣírasen es la matriz de impulso donde las diferencias de tensión se condensan, se abren en vórtices y reciben su primera orientación rítmica.",
        "def_long": "Dentro de La Katûvýs, Lulæṣírasen ocupa una centralidad funcional de puesta en movimiento. Esta matriz de impulso reúne las intensidades todavía latentes, cataliza su circulación y les da una curvatura practicable. Abre ciclos, inversiones y cambios de estado mediante oscilación, contracción y expansión en voluta, sin producir una forma cerrada: su gesto primero consiste en hacer posible la transmutación.\n\nSu acción puede desplegarse mediante varias configuraciones de vórtice. El vórtice libre corresponde a una emergencia espontánea desde el campo; el vórtice forzado responde a una presión periférica o a la interacción con otros órganos; el vórtice toroidal organiza un retorno en bucle donde la recurrencia se vuelve transformación; las cadenas de vórtices alternados acompañan los pasos entre sintonías diferenciadas. Estas figuras pertenecen a la poiética funcional del corpus y describen regímenes de circulación, curvatura y relanzamiento.\n\nLulæṣírasen impulsa y orienta; Takimarah ajusta la intensidad, la velocidad y la dirección del movimiento. Taxiêlîs articula los pivotes de fase, Tiqqunbahu retoma los motivos recurrentes, mientras Katûvýsissence inscribe las trayectorias como huellas reactivables. Lulæṣírasen actúa así como foco intrakatûvýsico de iniciación, en sintonía interior con la Posœnnoïa y distinto de Extratinrieur, que abre la interfaz entre interioridad, exterioridad, percepción y transmisión.",
        "h_features": "Función y dinámica interna",
        "h_questions": "Configuraciones de vórtice y activación",
        "hint_fold": "desplegar",
        "hint_fold2": "desplegar",
        "hint_fold3": "desplegar",
        "example_title": "Frase operativa",
        "example": "« Lulæṣírasen: condenso la diferencia, abro el impulso y la espiral se convierte en paso vivo hacia la recomposición. »",
        "features": [
            "Lulæṣírasen pertenece a Katûsýs, la banda de los ocho órganos internos de La Katûvýs. Su centralidad es funcional y relacional: nombra el foco donde una intensidad se vuelve movimiento, antes que un centro dominante o un origen exterior a la matriz-sustrato.",
            "Su función consiste en condensar las diferencias de tensión, poner en vibración las potencialidades del campo, catalizar las circulaciones y orientar sus variaciones. El impulso se vuelve ritmo, el ritmo se vuelve curvatura y la curvatura abre un umbral de transmutación.",
            "El movimiento iniciado por Lulæṣírasen permanece modulable. Puede intensificarse, contraerse, cambiar de sentido rotatorio, invertirse o redistribuirse según las necesidades del campo. Takimarah asegura entonces la regulación direccional y la tenida de las variaciones, dentro de una interdependencia donde Lulæṣírasen impulsa y Takimarah regula."
        ],
        "questions": [
            "La activación de Lulæṣírasen resulta pertinente cuando una tensión permanece disponible sin encontrar todavía su dirección, cuando un ciclo exige un impulso inicial o cuando una transformación requiere curvatura en vez de un empuje lineal.",
            "En un vórtice libre, el movimiento emerge del propio campo. En un vórtice forzado, una presión periférica sostiene o amplifica la rotación. El vórtice toroidal organiza una circulación en bucle, mientras las cadenas de vórtices alternados sostienen las transiciones entre varias sintonías.",
            "El referente operativo permanece claro: cuando el campo pide movimiento, Lulæṣírasen impulsa; cuando ese impulso exige medida, canalización y estabilidad móvil, Takimarah regula su despliegue."
        ],
        "h_family": "Relaciones sistémicas",
        "family_1": "<p><strong>Dentro de Katûsýs:</strong> Lulæṣírasen inicia el empuje rítmico; Taxiêlîs forma los pivotes donde las sintonías se condensan y redistribuyen; Tiqqunbahu recibe las recurrencias como motivos diferenciados; Takimarah modula diferencias, velocidades y orientaciones. Esta circulación forma una mecánica relacional donde el impulso conserva su potencia y permanece habitable.</p>",
        "family_2": "<p><strong>Dentro de La Katûvýs:</strong> las trayectorias procedentes de Lulæṣírasen se inscriben en Katûvýsissence como memorias dinámicas, pueden atravesar Extratinrieur hacia los campos perceptivos y expresivos, y participar después en la emergencia de Balakallpa. Lulæṣírasen constituye así una interfaz interna entre la matriz energética y la Posœnnoïa, sin sustituir la función propia de ninguna.</p>",
        "h_wordbuild": "Morfogénesis lingüística y frecuencia-guía 136",
        "word_blocks": [
            {
                "head": "Lule’a — bucle, vínculo y relanzamiento",
                "text": "Lule’a constituye una transposición morfogenética posœnnoïal elaborada a partir del hebreo lula’a, « bucle ». El segmento porta la lógica del retorno, del vínculo cíclico y de la tensión retenida antes de la apertura."
            },
            {
                "head": "ṣí — apertura del paso",
                "text": "El yorùbá ṣí porta el gesto de abrir, despejar o descubrir. En Lulæṣírasen, esta apertura transforma el bucle retenido en umbral operativo y libera la posibilidad del movimiento."
            },
            {
                "head": "rasen — curvatura espiral",
                "text": "El japonés rasen, 螺旋, significa espiral o hélice. Da al paso su rotación, su profundidad y su capacidad de expansión, para que la apertura se vuelva trayectoria en lugar de simple ruptura."
            },
            {
                "head": "Frecuencia-guía 136",
                "text": "La transliteración canónica LULEASIRASEN produce 136: L(12) + U(21) + L(12) + E(5) + A(1) + S(19) + I(9) + R(18) + A(1) + S(19) + E(5) + N(14). La reducción 1 + 3 + 6 = 10, y luego 1, devuelve la dinámica a la unidad-fuente y al impulso inicial. Dentro del corpus, este valor actúa como firma simbólica interna y carece de equivalencia con una frecuencia física medida en hercios."
            }
        ],
        "word_notes": [
            "La construcción Lule’a + ṣí + rasen pertenece a la Addition synchrêtique: cada procedencia permanece reconocible, mientras su articulación produce un nuevo término-concepto propio del corpus.",
            "El título Lulæṣírasen, el elemento La Katûvýs, el tótem Êkhö y los demás términos canónicos permanecen sin cambios en las tres lenguas."
        ],
        "cta_translate": "Proponer una traducción del concepto"
    }
};

  /* --------------------------------------------------------------------------
   * SLOTS
   * -------------------------------------------------------------------------- */

  function setSlotText(root, slot, txt){
    var el = root.querySelector("[data-po-slot='" + slot + "']");
    if (!el) return;
    el.textContent = clampStr(txt);
  }

  function setSlotHTML(root, slot, html){
    var el = root.querySelector("[data-po-slot='" + slot + "']");
    if (!el) return;
    el.innerHTML = protectKeywordsHTML(clampStr(html));
  }

  function setSlotImg(root, slot, src, alt){
    var el = root.querySelector("[data-po-slot='" + slot + "']");
    if (!el) return;

    var s = clampStr(src);
    var a = clampStr(alt);

    if (!s){
      try{ el.removeAttribute("src"); }catch(e){}
      try{ el.setAttribute("alt", ""); }catch(e){}
      try{ el.setAttribute("hidden", ""); }catch(e){}
      try{ el.style.display = "none"; }catch(e){}
      return;
    }

    try{ el.setAttribute("src", s); }catch(e){}
    try{ el.setAttribute("alt", a); }catch(e){}
    try{ el.removeAttribute("hidden"); }catch(e){}
    try{ el.style.display = ""; }catch(e){}
  }

  function ensureFourthChipSlot(root){
    if (!root) return;
    var meta = root.querySelector(".po-axis-meta");
    if (!meta) return;
    if (meta.querySelector("[data-po-slot='chip_4']")) return;

    var block = document.createElement("div");
    block.className = "po-axis-chipblock";

    var label = document.createElement("span");
    label.className = "po-axis-chip";
    label.setAttribute("data-po-slot", "chip_4");

    var img = document.createElement("img");
    img.className = "po-axis-chip__img";
    img.setAttribute("data-po-slot", "chip_4_img");
    img.setAttribute("src", "");
    img.setAttribute("alt", "");
    img.setAttribute("loading", "lazy");
    img.setAttribute("decoding", "async");
    img.setAttribute("hidden", "");

    block.appendChild(label);
    block.appendChild(img);
    meta.appendChild(block);
  }

  function renderProseInto(root, slot, items){
    var el = root.querySelector("[data-po-slot='" + slot + "']");
    if (!el) return;

    var arr = Array.isArray(items) ? items : [];
    var out = [];
    el.classList.add("po-axis-prose-list");

    for (var i=0;i<arr.length;i++){
      out.push(
        '<li class="po-axis-prose-item">' +
        protectKeywordsHTML(escapeHTML(clampStr(arr[i]))) +
        '</li>'
      );
    }

    el.innerHTML = out.join("");
  }

  function renderWordBlocks(root, slot, blocks){
    var host = root.querySelector("[data-po-slot='" + slot + "']");
    if (!host) return;
    var arr = Array.isArray(blocks) ? blocks : [];
    var out = [];
    for (var i=0;i<arr.length;i++){
      var b = arr[i] || {};
      var h = clampStr(b.head || "");
      var t = clampStr(b.text || "");
      out.push(
        '<div class="po-axis-wb">' +
          '<div class="po-axis-wb__h">' + protectKeywordsHTML(escapeHTML(h)) + '</div>' +
          '<div class="po-axis-wb__t">' + protectKeywordsHTML(escapeHTML(t)).replace(/\n/g,"<br />") + '</div>' +
        '</div>'
      );
    }
    host.innerHTML = out.join("");
  }

  function setCtaTranslate(root, lang){
    var el = root.querySelector('[data-po-slot="cta_translate"]');
    if (!el) return;
    el.textContent = clampStr((FALLBACK[lang] && FALLBACK[lang].cta_translate) || FALLBACK.fr.cta_translate);
  }

  function updateButtons(root, lang){
    qsa(root, ".po-langbtn").forEach(function(btn){
      var isActive = btn.getAttribute("data-po-lang") === lang;
      btn.setAttribute("aria-pressed", isActive ? "true" : "false");
      btn.classList.toggle("is-active", isActive);
    });
  }

  function resolveMainEntry(root){
    var id = "";
    try{ id = root.getAttribute("data-po-lex-id") || ""; }catch(e){ id = ""; }
    return (
      getLexiconEntry(id) ||
      getLexiconEntry("lulaesirasen") ||
      getLexiconEntry("Lulæṣírasen") ||
      getLexiconEntry("lulæṣírasen") ||
      null
    );
  }

  function chooseFallback(lang){
    var l = normLang(lang);
    return FALLBACK[l] || FALLBACK.fr;
  }

  function renderAxis(root, lang){
    var L = chooseFallback(lang);
    var eMain = resolveMainEntry(root);

    ensureFourthChipSlot(root);

    var titleFR = (eMain ? (pickTerm(eMain, "fr")) : "") || FALLBACK.fr.title;
    setSlotText(root, "title", titleFR);
    setSlotImg(root, "title_img", IMG_IDEOGRAM_CONCEPT, titleFR + " — idéogramme conceptuel");

    var kicker = "";
    if (eMain){
      kicker =
        clampStr(pickAny(eMain, "kicker_" + lang, "")) ||
        clampStr(pickAny(eMain, "kicker_fr", "")) ||
        clampStr(pickAny(eMain, "kicker", ""));
    }
    setSlotHTML(root, "kicker", kicker || L.kicker);

    setSlotText(root, "h_def", L.h_def);
    setSlotText(root, "chip_1", (L.chips && L.chips[0]) || "");
    setSlotText(root, "chip_2", (L.chips && L.chips[1]) || "");
    setSlotText(root, "chip_3", (L.chips && L.chips[2]) || "");
    setSlotText(root, "chip_4", (L.chips && L.chips[3]) || "");

    setSlotImg(root, "chip_1_img", IMG_IDEOGRAM_FUNCTION, titleFR + " — idéogramme fonctionnel");
    setSlotImg(root, "chip_2_img", IMG_ELEMENT, (L.chips && L.chips[1]) || "La Katûvýs");
    setSlotImg(root, "chip_3_img", IMG_TOTEM, (L.chips && L.chips[2]) || "Êkhö");
    setSlotImg(root, "chip_4_img", IMG_FREQ_136, (L.chips && L.chips[3]) || "Fréquence-guide 136");

    setSlotHTML(root, "def_short", "<div>" + protectKeywordsHTML(escapeHTML(L.def_short)) + "</div>");
    setSlotHTML(root, "def_long", "<div>" + protectKeywordsHTML(escapeHTML(L.def_long)).replace(/\n/g,"<br />") + "</div>");

    setSlotText(root, "h_features", L.h_features);
    setSlotText(root, "hint_fold", L.hint_fold);
    renderProseInto(root, "features", L.features || []);

    setSlotText(root, "h_questions", L.h_questions);
    setSlotText(root, "hint_fold2", L.hint_fold2);
    renderProseInto(root, "questions", L.questions || []);
    setSlotHTML(
      root,
      "example_box",
      '<div><strong>' + protectKeywordsHTML(escapeHTML(L.example_title || "Ex.")) + '</strong> ' +
      protectKeywordsHTML(escapeHTML(L.example || "")) + '</div>'
    );

    setSlotText(root, "h_family", L.h_family);
    setSlotText(root, "hint_fold3", L.hint_fold3);
    setSlotHTML(root, "family_1", L.family_1 || "");
    setSlotHTML(root, "family_2", L.family_2 || "");

    setSlotText(root, "h_wordbuild", L.h_wordbuild);
    renderWordBlocks(root, "wordbuild_blocks", L.word_blocks || []);
    renderProseInto(root, "wordbuild_notes", L.word_notes || []);

    setCtaTranslate(root, lang);
    updateButtons(root, lang);
    ensureAudioButtons(root, lang);
    refreshAudioButtons(root, lang);
  }

  function renderAll(lang){
    var l = normLang(lang || getLang());
    var roots = document.querySelectorAll(ROOT_SEL);
    for (var i=0;i<roots.length;i++){
      renderAxis(roots[i], l);
    }
  }

  function init(){
    renderAll(getLang());
  }

  function setLang(lang){
    var l = storeLang(lang);
    renderAll(l);
    notifyLocaleChanged();
  }

  window.addEventListener("po:lexicon-ready", function(){
    try{
      __PO_PROTECT_CACHE__.key = "";
      renderAll(getLang());
    }catch(e){}
  });

  window.PoKatupirsia5LulaesirasenTextsFR_EN_ES_20260303 = {
    getLang: getLang,
    setLang: setLang,
    init: init,
    stopAudio: stopAudio
  };

  if (document.readyState === "loading"){
    document.addEventListener("DOMContentLoaded", init);
  }else{
    init();
  }
})();
